import { toWSDateString } from "@wingspanhq/fe-component-library";
import { Batch } from "@wingspanhq/wingspan-api-sdk";

import { selectorImportBatchUploadedFilename } from "./selectorImportBatchUploadedFilename";
import { selectorIsImportBatchFileUploaded } from "./selectorIsImportBatchFileUploaded";

type Args = {
  batch: Batch;
  /** Singular noun for what the batch imports, e.g. "Payable", "Contractor". */
  entityLabel: string;
};

/**
 * Heading and sub-heading for a batch: the name the user gave it, falling back
 * to the uploaded spreadsheet and then to the creation date. The filename is
 * only a sub-heading once it is no longer doing duty as the name.
 */
export const selectorImportBatchNames = (
  args: Args
): { batchName: string; batchFileName?: string } => {
  const date = args.batch.events?.createdAt
    ? toWSDateString(args.batch.events.createdAt, "monthDayYear")
    : "";
  const name = args.batch.name;
  const fileName = selectorIsImportBatchFileUploaded(args.batch)
    ? selectorImportBatchUploadedFilename({
        batch: args.batch,
        entityLabel: args.entityLabel
      })
    : undefined;

  return {
    batchName: name || fileName || date || "--",
    batchFileName: name ? fileName : undefined
  };
};
